export const parkingSystemsOfAmericaStyles = {
	header: {
		backgroundColor: '#343232',
	},
	sidebar: {
		backgroundColor: '#018FCE',
		color: 'white',
	},
	button: {
		backgroundColor: '#018FCE',
		color: '#002682',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#0067B6',
		},
	},
	title: {
		color: '#fff',
	},
	text: {
		color: '#002682',
		buttonLoadingColor: '#0067B6',
	},
	table: {
		headerBackgroundColor: '#002682',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Parking Systems of America Platform',
	},
	logo: {
		small: {
			src: '/parkingSystemsOfAmerica/logo-parking-systems-of-america-color.svg',
			height: 90,
			width: 50,
		},
		large: {
			src: '/parkingSystemsOfAmerica/logo-parking-systems-of-america-horizontal-color.svg',
			height: 90,
			width: 150,
		},
	},
	favicon: {
		src: '/parkingSystemsOfAmerica/logo-parking-systems-of-america-color.svg',
	},
	socials: {},
	siteUrl: 'https://parkingsystemsofamerica.com/',
	orgName: 'Parking Systems Of America',
};
